//import * as React from "react";
import { dxDateBoxOptions } from "devextreme/ui/date_box";
import { useMemo } from "react";

const useContstanten = () => {

    const activiteiten = useMemo((): { id: number, text: string }[] => [
        { id: 0, text: "Huuractiviteiten" },
        { id: 1, text: "Koopactiviteiten" }
    ], [])

    const visitatieronden = useMemo((): { id: number, text: string }[] => [
        { id: 1, text: "1e visitatieronde" },
        { id: 2, text: "2e visitatieronde" }
    ], [])

    const operationeleDoelstellingScore = useMemo((): { id: number, text: string }[] => [
        { id: 0, text: "Goed" },
        { id: 1, text: "Zeer goed" },
        { id: 2, text: "Uitstekend" }
    ], [])

    const dateOptions = useMemo((): dxDateBoxOptions => ({
        dateSerializationFormat: "yyyy-MM-dd",
        displayFormat: "dd/MM/yyyy",
        placeholder: "dd/mm/yyyy",
        openOnFieldClick: true
    }), [])


    return { activiteiten, visitatieronden, operationeleDoelstellingScore, dateOptions };
}
export default useContstanten;